const prefix = '@@KANDY/WEBRTC/'

/**
 * Device action types.
 */
export const DEVICES_CHANGE = prefix + 'DEVICES/CHANGE'
export const INITIALIZE_DEVICES = prefix + 'INITIALIZE_DEVICES'
export const INITIALIZE_DEVICES_FINISH = prefix + 'INITIALIZE_DEVICES_FINISH'

/**
 * Track action types.
 */
const trackPrefix = prefix + 'TRACK/'

export const TRACK_ADDED = trackPrefix + 'ADDED'
export const TRACK_REMOVED = trackPrefix + 'REMOVED'

export const RENDER_TRACKS = trackPrefix + 'RENDER'
export const RENDER_TRACKS_FINISH = trackPrefix + 'RENDER_FINISH'

export const REMOVE_TRACKS = trackPrefix + 'REMOVE'
export const REMOVE_TRACKS_FINISH = trackPrefix + 'REMOVE_FINISH'

export const MUTE_TRACKS = trackPrefix + 'MUTE'
export const MUTE_TRACKS_FINISH = trackPrefix + 'MUTE_FINISH'
export const UNMUTE_TRACKS = trackPrefix + 'UNMUTE'
export const UNMUTE_TRACKS_FINISH = trackPrefix + 'UNMUTE_FINISH'

export const TRACK_SOURCE_MUTED = trackPrefix + 'SOURCE_MUTED'
export const TRACK_SOURCE_UNMUTED = trackPrefix + 'SOURCE_UNMUTED'

/**
 * Session action types.
 */
const sessionPrefix = prefix + 'SESSION/'

export const SESSION_ADDED = sessionPrefix + 'ADDED'
export const SESSION_REMOVED = sessionPrefix + 'REMOVED'

export const SESSION_NEW_TRACK = sessionPrefix + 'NEW_TRACK'
export const SESSION_TRACK_ENDED = sessionPrefix + 'TRACK_ENDED'
export const SESSION_CHANGE = sessionPrefix + 'CHANGE'
export const SESSION_TRACK_REPLACED = sessionPrefix + 'TRACK_REPLACED'

// Peer events
export const SESSION_ICE_CONNECTION_STATE_CHANGE = sessionPrefix + 'ICE_CONNECTION_STATE_CHANGE'
export const SESSION_ICE_GATHERING_STATE_CHANGE = sessionPrefix + 'ICE_GATHERING_STATE_CHANGE'
export const SESSION_ICE_CANDIDATE_COLLECTED = sessionPrefix + 'ICE_CANDIDATE_COLLECTED'
export const SESSION_ICE_COLLECTION_SCHEDULED_CHECK = sessionPrefix + 'ICE_CANDIDATE_SCHEDULED_CHECK'

/**
 * Media action types.
 */
const mediaPrefix = prefix + 'MEDIA/'

export const MEDIA_NEW = mediaPrefix + 'NEW'
export const MEDIA_REMOVED = mediaPrefix + 'REMOVED'
export const MEDIA_CHANGE = mediaPrefix + 'CHANGE'

export const MEDIA_NEW_TRACK = mediaPrefix + 'NEW_TRACK'
export const MEDIA_TRACK_ENDED = mediaPrefix + 'TRACK_ENDED'

/**
 * Misc. action types.
 */
export const SET_BROWSER_DETAILS = prefix + 'SET_BROWSER_DETAILS'
